import Vue from 'vue'
import moment from 'moment'

const state = {
  archive: null
}

const mutations = {
  SET_ARCHIVE (state, archive) {
    state.archive = archive
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return {}
    /* return Vue.prototype.$axios.get('inventory-archive')
      .then(response => {
        commit('SET_ARCHIVE', response.data)
      }) */
  }
}

const getters = {
  getAll: state => {
    return state.archive
  },
  fetchById: state => id => {
    return state.archive[id]
  },
  getExpiryInfo: state => id => {
    var now = moment()
    var then = moment(state.archive[id].expiry_date)
    return {
      fromNow: then.diff(now, 'seconds')
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
